export default __webpack_public_path__ + "68ce324539dd4256dd0be2173f60cfaa.png";